module.exports = __webpack_public_path__ + "img/extensions.6efcd6a1.svg";